<template>
  <el-dialog
    :title="title"
    :visible.sync="showDialog"
    append-to-body
    top="40px"
    width="1000px"
  >
    <div slot="title">
      <div class="title" v-if="!editing">
        <h2>{{ title }}</h2>
        <el-button
          size="small"
          style="margin-left: 10px"
          @click="editing = true"
          icon="el-icon-edit"
          >编辑标题</el-button
        >
      </div>
      <div v-else class="edit-title" style="width: 500px">
        <el-input v-model="title" placeholder="请输入内容"></el-input>
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="editing = false"
          >确定</el-button
        >
      </div>
    </div>
    <Cheditor
      ref="cheditor"
      v-loading="loading"
      v-if="showDialog"
      v-model="content"
    />
    <div class="btns">
      <el-button
        v-if="notaryStatus == 2"
        type="primary"
        size="small"
        @click="save"
        :loading="btnLoading"
        >保存</el-button
      >
      <el-tooltip
        v-else
        class="item"
        effect="dark"
        content="已审核的模版无法更改"
        placement="top"
      >
        <el-button type="primary" size="small">保存</el-button>
      </el-tooltip>
    </div>
  </el-dialog>
</template>

<script>
import Cheditor from "@/components/cheditor";
export default {
  components: {
    Cheditor,
  },
  data() {
    return {
      showDialog: false,
      templateId: "",
      type: "",
      content: "",
      btnLoading: false,
      notaryStatus: null,
      title: "模板详情",
      showCheditor: false,
      loading: false,
      editing: false,
      templateNo: "",
    };
  },
  mounted() {},
  watch: {
    showDialog: {
      handler(newValue) {
        setTimeout(() => {
          this.showCheditor = newValue;
        }, 100);
      },
    },
  },
  methods: {
    saveTitle() {},
    open(templateId, type, notaryStatus) {
      console.log(templateId, type, notaryStatus);
      this.loading = true;
      this.editing = false;
      this.showDialog = true;
      this.templateId = templateId;
      this.type = type;
      this.notaryStatus = notaryStatus;
      console.log("this.notaryStatus", this.notaryStatus);
      if (type === "tem" || type === "fujianTem") {
        this.getTemDetails(templateId);
      } else if (type === "docTem") {
        this.getDocTemDetails(templateId);
      } else if (type === "add") {
        this.content = "";
        this.title = "新增模板";
        return;
      }
      let alerted = sessionStorage.getItem("alerted");
      if (!alerted) {
        this.$alert("花括号包裹的内容为填充变量，如无必要请勿改动！", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            sessionStorage.setItem("alerted", true);
          },
        });
      }
    },
    close() {
      this.showDialog = false;
    },
    // 获取公证文书模板详情
    getDocTemDetails(templateId) {
      this.$api
        .getDocTemDetails(templateId)
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.content = res.data.data.templateInfo;
              this.loading = false;
            }, 1500);
            this.title = res.data.data.templateName;
            this.templateNo = res.data.data.templateNo;
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1500);
        });
    },
    // 获取业务模板详情
    getTemDetails(templateId) {
      this.$api
        .getTemDetails(templateId)
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.content = res.data.data.templateInfo;
              this.loading = false;
            }, 1500);
            this.title = res.data.data.templateName;
            this.templateNo = res.data.data.templateNo;
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1500);
        });
    },
    // 保存
    save() {
      if (this.content === "") {
        this.$message({
          message: "内容不能为空",
          type: "warning",
        });
        return;
      }
      console.log(this.type);
      let request;
      let reqData;
      if (this.type === "tem" || this.type === "fujianTem") {
        request = this.$api.updateTemplate;
        reqData = {
          templateId: this.templateId,
          templateName: this.title,
          templateNo: this.templateNo,
          templateInfo: this.content,
        };
      } else if (this.type === "docTem") {
        request = this.$api.editNotaryDocTemplate;
        reqData = {
          templateId: this.templateId,
          templateName: this.title,
          // templateNo: this.templateNo,
          templateInfo: this.content
        };
      }
      this.btnLoading = true;
      request(reqData)
        .then((res) => {
          if(res) {
            console.log("修改成功");
            this.$emit("updateList");
            this.close();
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../style/mixin";
.btns {
  margin-top: 20px;
  .flex(flex-end);
}
.title,
.edit-title {
  .flex();
}
/deep/ .w-e-text-container {
  height: 670px !important; /*!important是重点，因为原div是行内样式设置的高度300px*/
}
/deep/ .el-dialog__body {
  padding-top: 0;
}
</style>